export const CONTENT_HEIGHT_VARIABLE = '--drawer-content-height';

export const TEST_ID = 'drawer';
